import moment from 'moment'

export const customerType = {
    id: '',
    name: '',
    createdBy: '',
    updatedBy: '',
    createdAt: moment().format('YYYY-MM-DD'),
    updatedAt: moment().format('YYYY-MM-DD'),
}

// export const memberManagementDetail = {
//     id: '',
//     firstName: '',
//     lastName: '',
//     email: '',
//     departmentName: '',
//     isVerified: false,
//     isVerifiedEmail: false,
//     createdAt : moment().format('YYYY-MM-DD'),
// }